import {
    Database,
    CheckCircle,
    Info,
    AlertTriangle,
    XCircle,
    X,
    LayoutDashboard,
    Users,
    UserCircle,
    User,
    Key,
    Eye,
    EyeOff,
    PackageOpen,
    LineChart,
    Landmark,
    CalendarCheck,
    FileText,
    ShoppingCart,
    Settings,
    ChevronDown,
    ChevronUp,
    Menu,
    Bell,
    CircleHelp,
    PlusSquare,
    Pencil,
    Trash2,
    Save,
    ChevronLeft,
    ChevronRight,
    Search,
    Ellipsis,
    MoreVertical,
    FileUp,
    FileDown,
    ChevronsLeft,
    ChevronsUp,
    ChevronsDown,
    ChevronsRight,
    Printer,
    FileJson,
    AreaChart,
    BarChart3,
    BarChart,
    Network,
    GanttChartSquare,
    PieChart,
    BarChart2,
    Settings2,
    LogOut,
    LogIn,
    ShoppingBag,
    Store,
    ShoppingBasket,
    Table,
    Table2,
    LayoutGrid,
    Columns,
    LocateFixed,
    ArrowDown,
    ArrowUp,
    ArrowLeft,
    ArrowRight,
    ArrowUpCircle,
    ArrowRightCircle,
    ArrowDownCircle,
    ArrowLeftCircle,
    ChevronFirst,
    ChevronLast,
    AlignCenter,
    AlignJustify,
    AlignLeft,
    AlignRight,
    Bold,
    Clipboard,
    Copy,
    Scissors,
    Outdent,
    Eraser,
    File,
    Type,
    Heading,
    Indent,
    Italic,
    Link,
    List,
    FileDigit,
    ListOrdered,
    ListTodo,
    Link2Off,
    ClipboardPaste,
    Paperclip,
    Pilcrow,
    Repeat,
    Undo,
    RefreshCw,
    RotateCcw,
    RotateCw,
    Strikethrough,
    Subscript,
    Superscript,
    FileArchive,
    Archive,
    FileAudio,
    FileCode,
    FileSpreadsheet,
    FileImage,
    FileVideo,
    FileSignature,
    FileWarning,
    FileMinus,
    FilePlus,
    FileQuestion,
    Mail,
    MailOpen,
    Send,
    Check,
    CheckCheck,
    SquareCheck,
    Square,
    Phone,
    PhoneForwarded,
    PhoneOff,
    PhoneCall,
    PhoneIncoming,
    User2,
    UserMinus,
    UserPlus,
    Home,
    Briefcase,
    UserCog,
    UserRound,
    UserX,
    UserCheck,
    UserRoundSearch,
    Contact,
    IdCard,
    Handshake,
    HandFist,
    Hand,
    Calendar,
    CalendarMinus,
    CalendarPlus,
    CalendarDays,
    CalendarRange,
    Map,
    MapPin,
    Lock,
    Unlock,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldQuestion,
    Filter,
    FilterX,
    Bot,
    BrainCircuit,
    History,
    ShieldOff,
    ArchiveRestore,
    Video,
    Code,
    Underline,
    Redo,
    AlertCircle,
    AlertOctagon,
    Monitor,
    Tablet,
    Smartphone,
    Highlighter,
    Cake,
    Maximize,
    Minimize,
    MousePointer2,
    Layout,
    Layers,
    Droplet,
    Image,
    AlignEndHorizontal,
    AlignEndVertical,
    AlignCenterHorizontal,
    AlignCenterVertical,
    AlignStartHorizontal,
    AlignStartVertical,
    Move,
    Globe,
    Hash,
    AtSign,
    SendHorizontal,
    MessageCircle,
    MessageSquare,
    MessageSquareText,
    Share2,
    Share,
    Heart,
    ThumbsUp,
    Megaphone,
    Flag,
    Bookmark,
    BookmarkCheck,
    Rss,
    Radio,
    RadioReceiver,
    Headphones,
    Speaker,
    Music,
    Music2,
    Music3,
    Camera,
    Circle,
    Plus,
    PlusCircle,
    FolderPlus,
    ListPlus,
    MessageSquarePlus,
    Loader,
    Loader2,
    LoaderPinwheel,
    Hourglass,
    Zap,
    ToggleLeft,
    CircleDot,
    GripVertical,
    ArrowUpDown,
    FileEdit,
    UploadCloud,
} from 'lucide-react';

// Brand icons from react-icons (Font Awesome family)
import {
    FaFacebook,
    FaFacebookF,
    FaFacebookMessenger,
    FaFacebookSquare,
    FaInstagram,
    FaLinkedin,
    FaYoutube,
    FaTiktok,
    FaPinterest,
    FaSnapchatGhost,
    FaWhatsapp,
    FaTelegram,
    FaDiscord,
    FaRedditAlien,
    FaGithub,
    FaBehance,
    FaDribbble,
    FaTwitter,
} from 'react-icons/fa';

import {
    FaXTwitter,
    FaThreads,
} from 'react-icons/fa6';

export const iconCategories = {
    'Devices': {
        monitor: Monitor,
        tablet: Tablet,
        smartphone: Smartphone,
        mobile: Smartphone,
    },
    'Common': {
        layoutDashboard: LayoutDashboard,
        dashboard: LayoutDashboard,
        layoutGrid: LayoutGrid,
        app: PackageOpen,
        settings: Settings,
        settingsAlt: Settings2,
        help: CircleHelp,
        menu: Menu,
        notifications: Bell,
        search: Search,
        history: History,
        lock: Lock,
        lockOpen: Unlock,
        refresh: RefreshCw,
        rotate: RotateCcw,
        mousePointer: MousePointer2,
        maximize: Maximize,
        minimize: Minimize,
        layout: Layout,
        layers: Layers,
        move: Move,
        hand: Hand,
        locateFixed: LocateFixed,
        zap: Zap,
        gripVertical: GripVertical,
    },
    'Actions': {
        add: PlusSquare,
        addCircle: PlusCircle,
        addSimple: Plus,
        edit: Pencil,
        draft: FileEdit,
        publish: UploadCloud,
        delete: Trash2,
        save: Save,
        send: Send,
        print: Printer,
        archive: Archive,
        unarchive: ArchiveRestore,
        check: Check,
        times: X,
        view: Eye,
        valid: CheckCircle,
        login: LogIn,
        logout: LogOut,
        copy: Copy,
        paste: ClipboardPaste,
        cut: Scissors,
        undo: Undo,
        redo: Redo,
        repeat: Repeat,
        key: Key,
    },
    'Navigation': {
        chevronUp: ChevronUp,
        chevronDown: ChevronDown,
        chevronLeft: ChevronLeft,
        chevronRight: ChevronRight,
        chevronDoubleUp: ChevronsUp,
        chevronDoubleDown: ChevronsDown,
        chevronDoubleLeft: ChevronsLeft,
        chevronDoubleRight: ChevronsRight,
        arrowUp: ArrowUp,
        arrowDown: ArrowDown,
        arrowLeft: ArrowLeft,
        arrowRight: ArrowRight,
        arrowCircleUp: ArrowUpCircle,
        arrowCircleDown: ArrowDownCircle,
        arrowCircleLeft: ArrowLeftCircle,
        arrowCircleRight: ArrowRightCircle,
        ellipsisH: Ellipsis,
        ellipsisV: MoreVertical,
    },
    'Users & Profile': {
        user: User,
        users: Users,
        profile: UserCircle,
        gender: User2,
        contact: Contact,
        idCard: IdCard,
        userGear: UserCog,
        userPlus: UserPlus,
        userMinus: UserMinus,
        userTimes: UserX,
        userCheck: UserCheck,
        userRound: UserRound,
        usersViewfinder: UserRoundSearch,
    },
    'Data & Charts': {
        database: Database,
        table: Table,
        table2: Table2,
        list: List,
        listPlus: ListPlus,
        columns: Columns,
        chart: PieChart,
        chartSimple: BarChart,
        chartGantt: GanttChartSquare,
        chartDiagram: Network,
        chartColumn: BarChart3,
        chartBar: BarChart2,
        chartArea: AreaChart,
        chartLine: LineChart,
        analytics: BarChart,
    },
    'Files': {
        file: File,
        folderPlus: FolderPlus,
        fileText: FileText,
        csv: FileDigit,
        excel: FileSpreadsheet,
        fileArchive: FileArchive,
        fileImage: FileImage,
        fileAudio: FileAudio,
        fileCode: FileCode,
        video: Video,
        media: Image, // Added media alias to fix the missing icon issue
        signature: FileSignature,
        fileWarning: FileWarning,
        filePlus: FilePlus,
        fileMinus: FileMinus,
        fileQuestion: FileQuestion,
        export: FileDown,
        import: FileUp,
        code: Code,
    },
    'Communication': {
        mail: Mail,
        email: Mail,
        messagePlus: MessageSquarePlus,
        phone: Phone,
        phoneFlip: PhoneForwarded,
        phoneSlash: PhoneOff,
        phoneSquare: PhoneCall,
        phoneVolume: PhoneIncoming,
    },
    'Business & Places': {
        briefcase: Briefcase,
        landmark: Landmark,
        banking: Landmark,
        home: Home,
        shop: Store,
        bag: ShoppingBag,
        cart: ShoppingCart,
        shopBasket: ShoppingBasket,
        booking: CalendarCheck,
        map: Map,
        mapPin: MapPin,
        mapLocationDot: MapPin,
    },
    'Date & Time': {
        calendar: Calendar,
        calendarCheck: CalendarCheck,
        calendarPlus: CalendarPlus,
        calendarMinus: CalendarMinus,
        calendarDays: CalendarDays,
        calendarWeek: CalendarRange,
        cakeCandles: Cake,
    },
    'Status & Alerts': {
        loader: Loader,
        spinner: Loader2,
        loaderPinwheel: LoaderPinwheel,
        hourglass: Hourglass,
        success: Check,
        successCircle: CheckCircle,
        successDouble: CheckCheck,
        successSquare: SquareCheck,
        info: Info,
        infoCircle: Info,
        warning: AlertTriangle,
        warningCircle: AlertCircle,
        error: XCircle,
        errorCircle: XCircle,
        alertCircle: AlertCircle,
        alertOctagon: AlertOctagon,
        alertTriangle: AlertTriangle,
        invalid: AlertTriangle,
        close: X,
        shield: Shield,
        shieldCheck: ShieldCheck,
        shieldAlert: ShieldAlert,
        shieldOff: ShieldOff,
        shieldHalved: Shield,
    },
    'Text Editor': {
        alignCenter: AlignCenter,
        alignJustify: AlignJustify,
        alignLeft: AlignLeft,
        alignRight: AlignRight,
        bold: Bold,
        italic: Italic,
        underline: Underline,
        strikethrough: Strikethrough,
        header: Heading,
        font: Type,
        type: Type,
        indent: Indent,
        outdent: Outdent,
        square: Square,
        link: Link,
        unLink: Link2Off,
        paperClip: Paperclip,
        paragraph: Pilcrow,
        subscript: Subscript,
        superscript: Superscript,
        eraser: Eraser,
        clipboard: Clipboard,
        listUl: List,
        listOl: ListOrdered,
        listTodo: ListTodo,
        highlighter: Highlighter,
        droplet: Droplet,
        image: Image,
        eye: Eye,
        eyeOff: EyeOff,
        eyeSlash: EyeOff,
        circle: Circle,
        checkSquare: SquareCheck,
        toggleLeft: ToggleLeft,
        circleDot: CircleDot,
        lineHeight: ArrowUpDown,
    },
    'AI & Technology': {
        robot: Bot,
        brain: BrainCircuit,
    },
    'Alignment': {
        alignStartHorizontal: AlignStartHorizontal,
        alignCenterHorizontal: AlignCenterHorizontal,
        alignEndHorizontal: AlignEndHorizontal,
        alignStartVertical: AlignStartVertical,
        alignCenterVertical: AlignCenterVertical,
        alignEndVertical: AlignEndVertical,
    },
    'Social Media': {
        globe: Globe,
        hash: Hash,
        atSign: AtSign,
        send: SendHorizontal,
        messageCircle: MessageCircle,
        messageSquare: MessageSquare,
        messageSquareText: MessageSquareText,
        share: Share,
        share2: Share2,
        heart: Heart,
        thumbsUp: ThumbsUp,
        megaphone: Megaphone,
        flag: Flag,
        bookmark: Bookmark,
        bookmarkCheck: BookmarkCheck,
        rss: Rss,
        radio: Radio,
        radioReceiver: RadioReceiver,
        headphones: Headphones,
        speaker: Speaker,
        music: Music,
        music2: Music2,
        music3: Music3,
        camera: Camera,
        // Brand icons
        facebook: FaFacebook,
        facebookF: FaFacebookF,
        facebookMessenger: FaFacebookMessenger,
        facebookSquare: FaFacebookSquare,
        instagram: FaInstagram,
        x: FaXTwitter,
        linkedin: FaLinkedin,
        youtube: FaYoutube,
        tiktok: FaTiktok,
        pinterest: FaPinterest,
        snapchat: FaSnapchatGhost,
        whatsapp: FaWhatsapp,
        telegram: FaTelegram,
        discord: FaDiscord,
        reddit: FaRedditAlien,
        threads: FaThreads,
        github: FaGithub,
        behance: FaBehance,
        dribbble: FaDribbble,
        twitter: FaTwitter,
    },
};

export const icons = Object.values(iconCategories).reduce((acc, category) => ({ ...acc, ...category }), {});